import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { GroupDTO } from 'src/app/shared/proxies';
import { APP_VERSION } from 'src/version';

@Component({
    selector: 'add-main-group',
    templateUrl: './main-group.component.html',
    styleUrls: ['./main-group.component.scss'],
})
export class MainGroupComponent implements OnInit {
    version: string;
    group: GroupDTO;

    constructor(public authService: AuthService, private route: ActivatedRoute) {
        this.version = APP_VERSION.version;
    }

    ngOnInit(): void {
        this.route.data.subscribe((data) => {
            this.group = data.group as GroupDTO;
        });
    }
}
